import { MOKA_SERVICE_HOST } from 'api/constants';

export const MODIFIER_HUB_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/control-panel/modifiers`;
export const ITEM_HUB_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/control-panel/items`;
export const CATEGORY_HUB_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/control-panel/categories`;
export const SALES_TYPE_HUB_URL_INVENTORY_V1 = `${MOKA_SERVICE_HOST}/inventory/v1/control-panel/sales-type`;
